import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import AnimateWrapper from '../util/AnimateWrapper';

const SuccessPage = () => {
    const navigate = useNavigate();

    return (<AnimateWrapper>
        <h2>Het verzoek is succesvol ingediend, wij nemen binnenkort contact met u op.</h2>
        <Button className="w-100" size="lg btn-block" onClick={() => navigate("/")}>Nog een pakket versturen</Button>
    </AnimateWrapper>);
}

export default SuccessPage;